export const FETCH_PROGRAM_CATEGORY_DETAILS = 'FETCH_PROGRAM_CATEGORY_DETAILS'
export const FETCH_PROGRAM_CATEGORY_DETAILS_SUCCESS =
  'FETCH_PROGRAM_CATEGORY_DETAILS_SUCCESS'
export const FETCH_PROGRAM_CATEGORY_DETAILS_FAILURE =
  'FETCH_PROGRAM_CATEGORY_DETAILS_FAILURE'
export const FETCH_PROGRAM_CATEGORY_DETAILS_CANCEL =
  'FETCH_PROGRAM_CATEGORY_DETAILS_CANCEL'
